import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, unref as _unref, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "formulario-modelo" }
const _hoisted_2 = { class: "header-flex" }
const _hoisted_3 = {
  key: 0,
  class: "botones-header"
}
const _hoisted_4 = {
  key: 1,
  class: "marco"
}
const _hoisted_5 = { class: "form-titulo" }
const _hoisted_6 = { class: "formulario-opcion" }
const _hoisted_7 = { class: "fila-select-periodo" }
const _hoisted_8 = {
  key: 0,
  class: "valor-readonly"
}
const _hoisted_9 = ["value"]
const _hoisted_10 = {
  class: "periodo-editor",
  title: "Periodo del proceso (año y semestre)"
}
const _hoisted_11 = {
  key: 0,
  class: "formulario-opcion"
}
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 0,
  class: "error-campo"
}
const _hoisted_14 = {
  key: 1,
  class: "formulario-opcion"
}
const _hoisted_15 = ["value"]
const _hoisted_16 = {
  key: 2,
  class: "formulario-opcion"
}
const _hoisted_17 = {
  key: 0,
  class: "texto-vacio"
}
const _hoisted_18 = {
  key: 1,
  class: "campus-grid"
}
const _hoisted_19 = ["value"]
const _hoisted_20 = { class: "campus-nombre" }
const _hoisted_21 = {
  key: 2,
  class: "texto-vacio",
  style: {"font-style":"italic"}
}
const _hoisted_22 = {
  key: 3,
  class: "error-campo"
}
const _hoisted_23 = { class: "formulario-opcion" }
const _hoisted_24 = {
  key: 0,
  class: "error-campo"
}
const _hoisted_25 = { class: "formulario-opcion" }
const _hoisted_26 = {
  class: "texto-vacio",
  style: {"font-style":"italic","margin-top":"0.25rem"}
}
const _hoisted_27 = {
  key: 4,
  class: "formulario-opcion"
}
const _hoisted_28 = ["value"]
const _hoisted_29 = {
  key: 0,
  class: "error-campo"
}
const _hoisted_30 = {
  key: 5,
  class: "formulario-opcion"
}
const _hoisted_31 = {
  key: 0,
  class: "valor-readonly"
}
const _hoisted_32 = {
  key: 0,
  class: "texto-vacio"
}
const _hoisted_33 = ["value"]
const _hoisted_34 = {
  key: 2,
  class: "error-campo"
}
const _hoisted_35 = {
  key: 0,
  class: "formulario-opcion"
}
const _hoisted_36 = ["value"]
const _hoisted_37 = {
  key: 0,
  class: "error-campo"
}
const _hoisted_38 = {
  key: 1,
  class: "formulario-opcion"
}
const _hoisted_39 = {
  key: 0,
  class: "loading"
}
const _hoisted_40 = {
  key: 1,
  class: "tabla tabla-asignacion"
}
const _hoisted_41 = ["onUpdate:modelValue"]
const _hoisted_42 = ["value"]
const _hoisted_43 = {
  key: 2,
  class: "texto-vacio"
}
const _hoisted_44 = {
  key: 3,
  class: "error-campo"
}
const _hoisted_45 = {
  key: 7,
  class: "formulario-opcion"
}
const _hoisted_46 = { class: "botones" }
const _hoisted_47 = ["disabled"]
const _hoisted_48 = {
  key: 2,
  class: "loading"
}
const _hoisted_49 = { class: "proceso-tabs" }
const _hoisted_50 = {
  class: "botones-header",
  style: {"margin-bottom":"1rem"}
}
const _hoisted_51 = ["disabled"]
const _hoisted_52 = {
  key: 0,
  class: "loading"
}
const _hoisted_53 = {
  key: 1,
  class: "texto-vacio"
}
const _hoisted_54 = {
  key: 2,
  class: "tabla"
}
const _hoisted_55 = { class: "acciones-fila" }
const _hoisted_56 = ["onClick"]
const _hoisted_57 = {
  key: 3,
  class: "marco",
  style: {"margin-top":"1.5rem"}
}
const _hoisted_58 = { class: "formulario-opcion" }
const _hoisted_59 = { class: "fila-form-doble" }
const _hoisted_60 = { class: "formulario-opcion" }
const _hoisted_61 = ["value"]
const _hoisted_62 = { class: "formulario-opcion" }
const _hoisted_63 = { style: {"display":"flex","gap":"0.4rem","align-items":"center"} }
const _hoisted_64 = { class: "formulario-opcion" }
const _hoisted_65 = { class: "campus-grid" }
const _hoisted_66 = ["value"]
const _hoisted_67 = { class: "campus-nombre" }
const _hoisted_68 = {
  key: 0,
  class: "error-campo"
}
const _hoisted_69 = { class: "grupo-campus-titulo" }
const _hoisted_70 = {
  key: 0,
  class: "texto-vacio"
}
const _hoisted_71 = {
  key: 1,
  class: "tabla tabla-mini"
}
const _hoisted_72 = {
  key: 2,
  class: "texto-vacio",
  style: {"font-style":"italic"}
}
const _hoisted_73 = { class: "formulario-opcion" }
const _hoisted_74 = { class: "botones" }
const _hoisted_75 = ["disabled"]
const _hoisted_76 = { class: "filtros-secundarios" }
const _hoisted_77 = { class: "filtro-grupo" }
const _hoisted_78 = ["value"]
const _hoisted_79 = { class: "filtro-grupo" }
const _hoisted_80 = {
  key: 0,
  class: "texto-vacio"
}
const _hoisted_81 = {
  key: 1,
  class: "tabla"
}
const _hoisted_82 = { class: "col-obs" }
const _hoisted_83 = { class: "acciones-fila" }
const _hoisted_84 = ["disabled", "onClick"]
const _hoisted_85 = ["onClick"]
const _hoisted_86 = ["disabled", "onClick"]
const _hoisted_87 = ["onClick"]
const _hoisted_88 = ["onClick"]
const _hoisted_89 = ["onClick"]
const _hoisted_90 = ["onClick"]
const _hoisted_91 = ["onClick"]
const _hoisted_92 = ["onClick"]
const _hoisted_93 = ["onClick"]
const _hoisted_94 = {
  key: 4,
  class: "overlay-modal"
}
const _hoisted_95 = { class: "modal-confirmacion" }
const _hoisted_96 = { class: "botones" }
const _hoisted_97 = ["disabled"]
const _hoisted_98 = ["disabled"]

import { ref, computed, onMounted, reactive, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'

import useAutenticar from '@/store/IngresoAutenticar'
import { useGestionProcesos } from '@/store/GestionProcesoAutoevaluacion'
import { useGestionVersiones } from '@/store/GestionVersiones'
import { useGestionProgramas } from '@/store/GestionPrograma'
import { useGestionTipoModelos } from '@/store/GestionTipoModelo'
import { useGestionCampus } from '@/store/GestionCampus'
import { useGestionIndicadorEvaluadores } from '@/store/GestionIndicadorEvaluadores'
import { useGestionUsuarios } from '@/store/GestionUsuario'
import { useComponentes } from '@/store/GestionComponentes'
import { useGestionIndicadores } from '@/store/GestionIndicadores'
import { useGestionIndicadorInstrumentos } from '@/store/GestionIndicadorInstrumentos'
import { useModelo } from '@/store/GestionModelo'
import { listarUsuarios } from '@/services/RegistroUsuariosService'
import { getTiposEjecucionModeloService } from '@/services/ProcesoAutoevaluacionService'
import {
  getCampusDisponiblesService,
  crearProcesoInstitucionalService,
  listarProcesosInstitucionalesService,
  type CampusDisponible,
  type ProcesoInstitucional,
  type EjecucionDeCampus,
} from '@/services/ProcesoInstitucionalService'
import type { TipoEjecucionModelo } from '@/services/ProcesoAutoevaluacionService'
import type { Proceso } from '@/interfaces/ProcesoAutoevaluacion'
import type { Usuario } from '@/interfaces/Usuario'
import type Componente from '@/interfaces/Componente'
import type Version from '@/interfaces/Versiones'
import MensajeFlotante from '@/components/MensajeFlotante.vue'
import LoadingOverlay from '@/components/LoadingOverlay.vue'
import MensajeConfirmacion from '@/components/MensajeConfirmacion.vue'
import AdjuntarInformesModal from '@/components/AdjuntarInformesModal.vue'
import { crearIndicadorEvaluadorService } from '@/services/IndicadorEvaluadorService'

interface AsignacionFallida {
  id_version:      number
  id_ejecucion:    number
  id_indicador:    number
  id_usuario:      number
  id_asignado_por: number | null
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ProcesoAutoevaluacionAdminView',
  emits: ['cambiar-modo'],
  setup(__props) {

/**
 * Vista administrativa de las ejecuciones.
 *
 * Vista enrutada. Obtiene sus datos a través de stores Pinia: no llama a `http`
 * ni a los servicios directamente.
 */



const router           = useRouter()
const route            = useRoute()
const authStore        = useAutenticar()
const procesosStore    = useGestionProcesos()
const versionesStore   = useGestionVersiones()
const programasStore   = useGestionProgramas()
const tipoModeloStore  = useGestionTipoModelos()
const campusStore      = useGestionCampus()
const evaluadoresStore  = useGestionIndicadorEvaluadores()
const usuariosStore     = useGestionUsuarios()
const componentesStore  = useComponentes()
const indicadoresStore           = useGestionIndicadores()
const indicadorInstrumentoStore  = useGestionIndicadorInstrumentos()
const modeloStore                = useModelo()

const campusDisponibles = ref<CampusDisponible[]>([])
const instNombre   = ref('')
const instCampus   = ref<number[]>([])
const instCriterio = ref<'ponderado' | 'simple'>('ponderado')

// Procesos institucionales generales (ProcesoInstitucional)
const procesosInstitucionales  = ref<ProcesoInstitucional[]>([])
const procesosInstitucionalesFiltrados = computed(() =>
  procesosInstitucionales.value.filter(pi => (pi.ejecuciones?.length ?? 0) >= 2)
)
const cargandoInstitucionales  = ref(false)
const mostrarFormVincular      = ref(false)
const guardandoVincular        = ref(false)
const campusParaVincular       = ref<number[]>([])
const formVincular = reactive({
  nombre:                 '',
  id_version:             0,
  periodo:                calcularPeriodo(),
  criterio_consolidacion: 'ponderado' as 'ponderado' | 'simple',
  observaciones:          '',
})

const tipoModeloSeleccionado = ref<number | null>(null)

const cargando                   = ref(false)
const guardando                  = ref(false)
const progresoAsignacion         = ref(0)
const totalAsignacion            = ref(0)
const mostrarFormulario          = ref(false)
const procesoAEliminar           = ref<number | null>(null)
// Adjuntar informes de ejecuciones antiguas
const adjuntarVisible            = ref(false)
const adjuntarIdEjecucion        = ref<number | null>(null)
const adjuntarPeriodo            = ref<string | null>(null)
const iniciandoId                = ref<number | null>(null)
const eliminando                 = ref(false)
const asignacionesFallidas       = ref<AsignacionFallida[]>([])
const mostrarReintentoAsignacion = ref(false)
const reintentandoAsignacion     = ref(false)
const mensajeVisible    = ref(false)
const mensajeTexto      = ref('')
const mensajeTipo       = ref<'positivo' | 'error'>('positivo')
const filtroEstado      = ref('')
const filtroTipo        = ref<'programa' | 'institucional' | 'institucional-general'>(
  route.query.tab === 'institucional-general' ? 'institucional-general'
  : route.query.tab === 'institucional' ? 'institucional'
  : 'programa'
)
const busqueda          = ref('')
const usuarios = ref<Usuario[]>([])

// Modo edición
const modoEdicion       = ref(false)
const procesoEnEdicion  = ref<Proceso | null>(null)
const cargandoEdicion   = ref(false)

// Formulario — responsables al crear/editar proceso
const usuarioResponsable           = ref<number | null>(null)
const componentesPrimerNivel       = ref<Componente[]>([])
const responsablesPorComponente    = reactive<Record<number, number | null>>({})
const cargandoComponentes          = ref(false)

// Estado inicial capturado al abrir el formulario de edición (para detectar cambios)
const responsableInicialPrograma         = ref<number | null>(null)
const responsablesInicialesComponentes   = reactive<Record<number, number | null>>({})


async function cargarComponentesPrimerNivel(idVersion: number): Promise<void> {
  cargandoComponentes.value = true
  try {
    const version = await versionesStore.getVersionById(idVersion) as Version | null
    const idModelo = version?.id_modelo
    if (!idModelo) return

    const raiz = await componentesStore.cargarRaizPorModelo(idModelo)
    if (!raiz?.id_componente) return
    await componentesStore.cargarArbolDesdeRaiz(raiz.id_componente)

    const raizNodo = componentesStore.componentes.find(c => c.id_componente === raiz.id_componente)
    if (!raizNodo?.children?.length) return

    componentesPrimerNivel.value = [...raizNodo.children].sort((a, b) =>
      (a.ordinal ?? '').localeCompare(b.ordinal ?? '', undefined, { numeric: true })
    )
    for (const comp of raizNodo.children) {
      if (comp.id_componente != null) responsablesPorComponente[comp.id_componente] = null
    }
  } catch {
    mostrarMensaje('Error al cargar la estructura del modelo.', 'error')
  } finally {
    cargandoComponentes.value = false
  }
}

function recopilarHojasDeRama(comp: Componente): Componente[] {
  if (!comp.children?.length) return [comp]
  const hojas: Componente[] = []
  for (const hijo of comp.children) hojas.push(...recopilarHojasDeRama(hijo))
  return hojas
}

async function asignarEnParalelo(asignaciones: AsignacionFallida[], tamanioLote = 20): Promise<AsignacionFallida[]> {
  if (!asignaciones.length) return []
  totalAsignacion.value = asignaciones.length
  progresoAsignacion.value = 0
  const fallidas: AsignacionFallida[] = []
  for (let i = 0; i < asignaciones.length; i += tamanioLote) {
    const lote = asignaciones.slice(i, i + tamanioLote)
    const resultados = await Promise.allSettled(
      lote.map(a => crearIndicadorEvaluadorService({
        id_version:      a.id_version,
        id_ejecucion:    a.id_ejecucion,
        id_indicador:    a.id_indicador,
        id_usuario:      a.id_usuario,
        id_asignado_por: a.id_asignado_por
      }))
    )
    lote.forEach((a, j) => {
      const r = resultados[j]
      if (r.status === 'rejected' || (r.status === 'fulfilled' && !r.value.ok)) fallidas.push(a)
    })
    progresoAsignacion.value += lote.length
  }
  return fallidas
}

async function asignarIndicadoresPorRama(
  idVersion: number,
  comp: Componente,
  idUsuario: number,
  idAsignadoPor: number | null,
  idEjecucion: number
): Promise<AsignacionFallida[]> {
  const hojas = recopilarHojasDeRama(comp)
  const asignaciones: AsignacionFallida[] = []
  for (const hoja of hojas) {
    if (!hoja.id_componente) continue
    const indicadores = indicadoresStore.indicadores.filter(
      i => i.id_componente === hoja.id_componente && i.id_version === idVersion && i.id_indicador != null
    )
    for (const ind of indicadores) {
      asignaciones.push({ id_version: idVersion, id_ejecucion: idEjecucion, id_indicador: ind.id_indicador!, id_usuario: idUsuario, id_asignado_por: idAsignadoPor })
    }
  }
  return asignarEnParalelo(asignaciones)
}

const opcionesEstado = [
  { label: 'Preparación', value: 'preparacion' },
  { label: 'Ejecución',   value: 'ejecucion'   },
  { label: 'Evaluación',  value: 'evaluacion'  },
  { label: 'Informe',     value: 'informe'     },
  { label: 'Finalizado',  value: 'finalizado'  }
]

function calcularPeriodo(): string {
  const now  = new Date()
  const year = now.getFullYear()
  return (now.getMonth() + 1) <= 6 ? `${year}-1` : `${year}-2`
}

function esProcesoHistorico(p: Proceso): boolean {
  if (p.periodo !== calcularPeriodo()) return true
  const idsIndicadores = new Set(
    indicadoresStore.indicadores
      .filter(i => i.id_version === p.id_version && i.id_indicador != null)
      .map(i => i.id_indicador as number)
  )
  if (idsIndicadores.size === 0) return false
  return !indicadorInstrumentoStore.relaciones.some(r => idsIndicadores.has(r.id_indicador))
}

const form = reactive<Omit<Proceso, 'id' | 'estado'>>({
  ambito:        '' as any,
  id_version:    0,
  periodo:       calcularPeriodo(),
  id_programa:   undefined,
  id_campus:     undefined,
  id_tipo_ejecucion_modelo: undefined,
  observaciones: ''
})

/** Catálogo de tipos de proceso (acreditación, reacreditación, renovación). */
const tiposEjecucion = ref<TipoEjecucionModelo[]>([])

const errores = reactive<Record<string, string>>({})

// Editor de periodo (formato "YYYY-S"): permite fijar periodos anteriores
// para procesos antiguos en lugar de tomar siempre el periodo actual.
const anioMaximo = new Date().getFullYear() + 1

const periodoAnio = computed<number>({
  get: () => {
    const n = parseInt(form.periodo.split('-')[0], 10)
    return Number.isFinite(n) ? n : new Date().getFullYear()
  },
  set: (v) => { form.periodo = `${v || new Date().getFullYear()}-${periodoSemestre.value}` }
})

const periodoSemestre = computed<string>({
  get: () => (form.periodo.split('-')[1] === '1' ? '1' : '2'),
  set: (v) => { form.periodo = `${periodoAnio.value}-${v}` }
})

function cerrarFormulario() {
  mostrarFormulario.value = false
  resetForm()
}

function resetForm() {
  form.ambito              = '' as any
  form.id_version          = 0
  form.periodo             = calcularPeriodo()
  form.id_programa         = undefined
  form.id_campus           = undefined
  form.id_tipo_ejecucion_modelo = undefined
  form.observaciones       = ''
  tipoModeloSeleccionado.value      = null
  usuarioResponsable.value          = null
  componentesPrimerNivel.value      = []
  modoEdicion.value                 = false
  procesoEnEdicion.value            = null
  for (const k in responsablesPorComponente) delete (responsablesPorComponente as any)[k]
  campusDisponibles.value = []
  instNombre.value   = ''
  instCampus.value   = []
  instCriterio.value = 'ponderado'
  mostrarFormVincular.value = false
  campusParaVincular.value  = []
  Object.keys(errores).forEach(k => delete errores[k])
}

async function abrirModificarProceso(proceso: Proceso) {
  resetForm()
  modoEdicion.value      = true
  procesoEnEdicion.value = proceso
  cargandoEdicion.value  = true
  mostrarFormulario.value = true

  const esPrograma = proceso.ambito === 'programa'
  const tipoEncontrado = tipoModeloStore.tipos.find(t =>
    esPrograma
      ? t.tipo.trim().toLowerCase().startsWith('programa')
      : !t.tipo.trim().toLowerCase().startsWith('programa')
  )
  tipoModeloSeleccionado.value = tipoEncontrado?.id_tipo_modelo ?? null

  form.ambito        = proceso.ambito
  form.id_version    = proceso.id_version
  form.id_campus     = proceso.id_campus
  form.id_programa   = proceso.id_programa
  form.periodo       = proceso.periodo
  form.id_tipo_ejecucion_modelo = proceso.id_tipo_ejecucion_modelo ?? undefined
  form.observaciones = proceso.observaciones ?? ''

  try {
    if (!usuarios.value.length) {
      const [usrs] = await Promise.all([listarUsuarios(), usuariosStore.me()])
      usuarios.value = usrs
    }

    if (proceso.id_campus) {
      await programasStore.cargarTodos(proceso.id_campus)
    }

    await cargarComponentesPrimerNivel(proceso.id_version)
    await evaluadoresStore.cargar({ id_version: proceso.id_version, id_ejecucion: proceso.id })

    if (esPrograma) {
      const asig = evaluadoresStore.asignaciones.find(a => a.id_indicador != null)
      usuarioResponsable.value = asig?.id_usuario ?? null
      responsableInicialPrograma.value = usuarioResponsable.value
    } else {
      if (!indicadoresStore.indicadores.length) await indicadoresStore.cargarTodos()
      for (const comp of componentesPrimerNivel.value) {
        if (!comp.id_componente) continue
        const hojas = recopilarHojasDeRama(comp)
        let idUsuario: number | null = null
        for (const hoja of hojas) {
          if (!hoja.id_componente || idUsuario) continue
          const inds = indicadoresStore.indicadores.filter(
            i => i.id_componente === hoja.id_componente && i.id_version === proceso.id_version
          )
          for (const ind of inds) {
            const asig = evaluadoresStore.asignaciones.find(a => a.id_indicador === ind.id_indicador)
            if (asig?.id_usuario) { idUsuario = asig.id_usuario; break }
          }
        }
        responsablesPorComponente[comp.id_componente] = idUsuario
      }
      // Capturar estado inicial para detectar cambios al guardar
      for (const k in responsablesInicialesComponentes) delete (responsablesInicialesComponentes as any)[k]
      for (const comp of componentesPrimerNivel.value) {
        if (comp.id_componente != null)
          responsablesInicialesComponentes[comp.id_componente] = responsablesPorComponente[comp.id_componente] ?? null
      }
    }
  } catch {
    mostrarMensaje('Error al cargar los datos del proceso.', 'error')
  } finally {
    cargandoEdicion.value = false
  }
}

async function modificarProceso() {
  if (!procesoEnEdicion.value?.id || !validarForm()) return
  guardando.value = true

  const id            = procesoEnEdicion.value.id
  const idEjecucion   = id!
  const esPrograma    = esTipoPrograma(tipoModeloSeleccionado.value)
  const idVersion     = form.id_version
  const idAsignadoPor = authStore.usuarioActual?.id ?? null
  const proc          = procesoEnEdicion.value

  // Detectar qué cambió
  const formCambiado =
    (form.id_campus  ?? null) !== (proc.id_campus  ?? null) ||
    (esPrograma && (form.id_programa ?? null) !== (proc.id_programa ?? null)) ||
    (form.observaciones?.trim() || null) !== (proc.observaciones?.trim() || null) ||
    form.periodo !== proc.periodo

  const responsableProgramaCambio = esPrograma &&
    usuarioResponsable.value !== responsableInicialPrograma.value

  const responsablesInstCambio = !esPrograma &&
    componentesPrimerNivel.value.some(c =>
      c.id_componente != null &&
      responsablesPorComponente[c.id_componente] !== responsablesInicialesComponentes[c.id_componente]
    )

  const asignacionesCambiaron = responsableProgramaCambio || responsablesInstCambio

  if (!formCambiado && !asignacionesCambiaron) {
    guardando.value = false
    cerrarFormulario()
    mostrarMensaje('No se detectaron cambios.', 'positivo')
    return
  }

  // PATCH solo si cambiaron campos del proceso
  if (formCambiado) {
    const result = await procesosStore.actualizar(id, {
      id_campus:     form.id_campus,
      id_programa:   esPrograma ? form.id_programa : undefined,
      observaciones: form.observaciones?.trim() || undefined,
      periodo:       form.periodo,
    })
    if (!result.ok) {
      guardando.value = false
      const msgs = result.errors ? Object.values(result.errors).flat().join(', ') : 'Error al actualizar el proceso'
      mostrarMensaje(msgs, 'error')
      return
    }
  }

  const todasFallidasMod: AsignacionFallida[] = []

  // Operaciones de asignación solo si cambiaron responsables
  if (asignacionesCambiaron) {
    await evaluadoresStore.cargar({ id_version: idVersion, id_ejecucion: idEjecucion })

    if (esPrograma) {
      if (usuarioResponsable.value) {
        const asignacionesActuales = evaluadoresStore.asignaciones.filter(a => a.id_indicador != null && a.id != null)
        await Promise.allSettled(asignacionesActuales.map(a => evaluadoresStore.eliminar(a.id!)))
        for (const comp of componentesPrimerNivel.value) {
          todasFallidasMod.push(...await asignarIndicadoresPorRama(idVersion, comp, usuarioResponsable.value, idAsignadoPor, idEjecucion))
        }
      }
    } else {
      const eliminaciones: number[] = []
      const nuevasAsignaciones: AsignacionFallida[] = []

      for (const comp of componentesPrimerNivel.value) {
        if (!comp.id_componente) continue
        const idUsuario = responsablesPorComponente[comp.id_componente]
        if (!idUsuario) continue
        const hojas = recopilarHojasDeRama(comp)
        for (const hoja of hojas) {
          if (!hoja.id_componente) continue
          const inds = indicadoresStore.indicadores.filter(
            i => i.id_componente === hoja.id_componente && i.id_version === idVersion && i.id_indicador != null
          )
          for (const ind of inds) {
            const existente = evaluadoresStore.asignaciones.find(a => a.id_indicador === ind.id_indicador)
            if (existente?.id_usuario === idUsuario) continue
            if (existente?.id) eliminaciones.push(existente.id)
            nuevasAsignaciones.push({ id_version: idVersion, id_ejecucion: idEjecucion, id_indicador: ind.id_indicador!, id_usuario: idUsuario, id_asignado_por: idAsignadoPor })
          }
        }
      }

      await Promise.allSettled(eliminaciones.map(id => evaluadoresStore.eliminar(id)))
      todasFallidasMod.push(...await asignarEnParalelo(nuevasAsignaciones))
    }
  }

  if (todasFallidasMod.length > 0) {
    const reintento = await asignarEnParalelo(todasFallidasMod)
    todasFallidasMod.length = 0
    todasFallidasMod.push(...reintento)
  }

  totalAsignacion.value = 0
  guardando.value = false
  cerrarFormulario()
  await procesosStore.cargarTodos()

  if (todasFallidasMod.length > 0) {
    asignacionesFallidas.value = todasFallidasMod
    mostrarReintentoAsignacion.value = true
    mostrarMensaje(`Proceso actualizado, pero ${todasFallidasMod.length} asignación(es) no se completaron.`, 'error')
  } else {
    mostrarMensaje('Proceso actualizado correctamente.', 'positivo')
  }
}

const idsVersionConProcesoActivo = computed(() =>
  new Set(
    procesosStore.procesos
      .filter(p => p.estado !== 'finalizado' && p.id_version != null)
      .map(p => p.id_version as number)
  )
)

const versionesFiltradas = computed(() => {
  if (tipoModeloSeleccionado.value === null) return []
  const modeloTipoMap = new Map(
    modeloStore.modelos.map(m => [m.id_modelo, m.id_tipo_modelo])
  )
  // Los procesos institucionales pueden correr en paralelo para campus distintos,
  // así que no se bloquea la versión aunque ya exista un proceso activo.
  const esPrograma = esTipoPrograma(tipoModeloSeleccionado.value)
  return versionesStore.versiones.filter(v => {
    const estadoOk =
      v.estado === 'aprobado' ||
      (v.estado === 'edicion' && (!esPrograma || !idsVersionConProcesoActivo.value.has(v.id_version!)))
    if (!estadoOk) return false
    return modeloTipoMap.get(v.id_modelo) === tipoModeloSeleccionado.value
  })
})

const nombresRepetidosVersion = computed(() => {
  const counts = new Map<string, number>()
  for (const v of versionesFiltradas.value) {
    counts.set(v.nombre, (counts.get(v.nombre) ?? 0) + 1)
  }
  return new Set([...counts.entries()].filter(([, n]) => n > 1).map(([nombre]) => nombre))
})

function etiquetaVersion(v: Version): string {
  if (!nombresRepetidosVersion.value.has(v.nombre)) return v.nombre
  const raw = v.fecha_aprobacion ?? v.fecha_creacion
  const d = new Date(raw)
  const dd = String(d.getDate()).padStart(2, '0')
  const mm = String(d.getMonth() + 1).padStart(2, '0')
  const aa = String(d.getFullYear()).slice(-2)
  return `${v.nombre} · ${dd}/${mm}/${aa}`
}

function esTipoPrograma(idTipo: number | null): boolean {
  if (idTipo === null) return false
  const tipo = tipoModeloStore.tipos.find(t => t.id_tipo_modelo === idTipo)
  return !!tipo && tipo.tipo.trim().toLowerCase().startsWith('programa')
}

watch(mostrarFormulario, async (abierto) => {
  if (abierto && !usuarios.value.length) {
    const [usrs] = await Promise.all([listarUsuarios(), usuariosStore.me()])
    usuarios.value = usrs
  }
})

watch(tipoModeloSeleccionado, async (idTipo) => {
  if (modoEdicion.value) return
  form.id_version  = 0
  form.id_programa = undefined
  form.id_campus   = undefined
  componentesPrimerNivel.value = []
  campusDisponibles.value = []
  instCampus.value = []
  for (const k in responsablesPorComponente) delete (responsablesPorComponente as any)[k]
  usuarioResponsable.value = null
  if (idTipo !== null && !esTipoPrograma(idTipo)) {
    campusDisponibles.value = await getCampusDisponiblesService()
  }
})

watch(() => form.id_campus, async (idCampus) => {
  if (modoEdicion.value) return
  form.id_programa = undefined
  await programasStore.cargarTodos(idCampus ?? undefined)
})

watch(() => form.id_version, () => {
  if (modoEdicion.value) return
  componentesPrimerNivel.value = []
  for (const k in responsablesPorComponente) delete (responsablesPorComponente as any)[k]
})

const areasPlanas = computed(() =>
  programasStore.programas
    .filter(p => p.nivel === 'pregrado' || p.nivel === 'posgrado')
    .map(p => ({ id: p.id_programa as number, label: p.nombre }))
)

function mostrarMensaje(texto: string, tipo: 'positivo' | 'error') {
  mensajeTexto.value   = texto
  mensajeTipo.value    = tipo
  mensajeVisible.value = true
}

const procesosOrdenados = computed(() =>
  [...procesosStore.procesos].sort((a, b) => (b.id ?? 0) - (a.id ?? 0))
)

const procesosFiltrados = computed(() => {
  let base = procesosOrdenados.value
  if (filtroEstado.value) base = base.filter(p => p.estado === filtroEstado.value)
  if (filtroTipo.value && filtroTipo.value !== 'institucional-general')
    base = base.filter(p => p.ambito === filtroTipo.value)
  if (busqueda.value.trim()) {
    const t = busqueda.value.trim().toLowerCase()
    base = base.filter(p => p.periodo.toLowerCase().includes(t))
  }
  return base
})

// ── ProcesoInstitucional general ─────────────────────────────────────

async function cargarProcesosInstitucionales(): Promise<void> {
  cargandoInstitucionales.value = true
  procesosInstitucionales.value = await listarProcesosInstitucionalesService()
  cargandoInstitucionales.value = false
}


function irAResultadosInstitucional(pi: ProcesoInstitucional): void {
  router.push({ name: 'ProcesosInstitucionales', query: { id: String(pi.id_proceso_institucional) } })
}

// Período del formulario de vinculación
const formVincularAnio = computed<number>({
  get: () => {
    const n = parseInt(formVincular.periodo.split('-')[0], 10)
    return Number.isFinite(n) ? n : new Date().getFullYear()
  },
  set: (v) => { formVincular.periodo = `${v || new Date().getFullYear()}-${formVincularSemestre.value}` }
})

const formVincularSemestre = computed<string>({
  get: () => (formVincular.periodo.split('-')[1] === '1' ? '1' : '2'),
  set: (v) => { formVincular.periodo = `${formVincularAnio.value}-${v}` }
})

// Procesos existentes por campus que coinciden con versión+período seleccionados
const procesosParaVincular = computed(() => {
  if (campusParaVincular.value.length < 2 || !formVincular.id_version || !formVincular.periodo) return []
  return campusParaVincular.value.map(idCampus => {
    const procesos = procesosStore.procesos.filter(p =>
      p.id_campus === idCampus &&
      p.ambito === 'institucional' &&
      p.id_version === formVincular.id_version &&
      p.periodo === formVincular.periodo
    )
    const campusNombre = campusStore.campus.find(c => c.id_campus === idCampus)?.nombre ?? `Campus ${idCampus}`
    return { idCampus, campusNombre, procesos }
  })
})

async function crearProcesoDesdeExistentes(): Promise<void> {
  if (!formVincular.nombre.trim() || !formVincular.id_version || campusParaVincular.value.length < 2) return
  guardandoVincular.value = true
  const result = await crearProcesoInstitucionalService({
    nombre:    formVincular.nombre.trim(),
    periodo:   formVincular.periodo,
    id_version: formVincular.id_version,
    criterio_consolidacion: formVincular.criterio_consolidacion,
    observaciones: formVincular.observaciones || null,
    campus: campusParaVincular.value,
  })
  guardandoVincular.value = false
  if (!result.ok) {
    mostrarMensaje(result.error ?? 'Error al crear el proceso institucional', 'error')
    return
  }
  mostrarFormVincular.value = false
  campusParaVincular.value = []
  Object.assign(formVincular, { nombre: '', id_version: 0, periodo: calcularPeriodo(), criterio_consolidacion: 'ponderado', observaciones: '' })
  await Promise.all([procesosStore.cargarTodos(), cargarProcesosInstitucionales()])
  mostrarMensaje('Proceso institucional general creado y procesos vinculados.', 'positivo')
}

function nombreVersion(idVersion: number): string {
  const version = versionesStore.versiones.find(v => v.id_version === idVersion)
  return version?.nombre ?? `#${idVersion}`
}

function nombrePrograma(idPrograma?: number | null): string {
  if (!idPrograma) return '—'
  const programa = programasStore.programas.find(p => p.id_programa === idPrograma)
  return programa?.nombre ?? `#${idPrograma}`
}

function irAComparativo(id?: number) {
  if (!id) {
    mostrarMensaje('No se pudo identificar la ejecución.', 'error')
    return
  }
  router.push({ name: 'ComparacionCalificaciones', params: { id_ejecucion: id } })
}

function irAResultados(id?: number) {
  if (!id) {
    mostrarMensaje('No se pudo identificar la ejecución.', 'error')
    return
  }
  router.push({ name: 'ResultadosAutoevaluacion', params: { id_ejecucion: id } })
}

function irAInforme(id?: number) {
  if (!id) {
    mostrarMensaje('No se pudo identificar la ejecución.', 'error')
    return
  }
  router.push({ name: 'InformeAutoevaluacion', params: { id_ejecucion: id } })
}

function irAPlanMejoramiento(id?: number) {
  if (!id) {
    mostrarMensaje('No se pudo identificar la ejecución.', 'error')
    return
  }
  router.push({ name: 'PlanMejoramiento', params: { id_ejecucion: id } })
}

function irAAsignarTareas(id?: number) {
  if (!id) {
    mostrarMensaje('No se pudo identificar la ejecución.', 'error')
    return
  }
  router.push({ name: 'AsignarTareasDirector', params: { id_ejecucion: id } })
}

function estadoClass(estado?: string | null) {
  const map: Record<string, string> = {
    preparacion: 'estado-modificar',
    ejecucion:   'estado-completado',
    evaluacion:  'estado-aprobado',
    informe:     'estado-aprobado',
    finalizado:  'estado-descontinuado'
  }
  return map[estado ?? ''] ?? 'estado-modificar'
}

function validarForm(): boolean {
  Object.keys(errores).forEach(k => delete errores[k])
  if (!form.id_version) errores.id_version = 'Selecciona una versión'
  // El backend también lo exige; validarlo aquí evita el viaje y el 422.
  if (!form.id_tipo_ejecucion_modelo)
    errores.id_tipo_ejecucion_modelo = 'Indica para qué se autoevalúa'
  const esPrograma = esTipoPrograma(tipoModeloSeleccionado.value)
  if (esPrograma && !form.id_programa)
    errores.id_programa = 'Selecciona un programa'
  if (esPrograma && !usuarioResponsable.value)
    errores.responsable = 'Selecciona un responsable'
  if (!esPrograma && !modoEdicion.value) {
    if (instCampus.value.length === 0)
      errores.campus = 'Selecciona al menos un campus'
    if (instCampus.value.length >= 2 && !instNombre.value.trim())
      errores.nombre = 'Ingresa un nombre para el proceso'
  }
  if (!esPrograma && modoEdicion.value) {
    const sinAsignar = componentesPrimerNivel.value.filter(
      c => c.id_componente != null && !responsablesPorComponente[c.id_componente!]
    ).length
    if (sinAsignar > 0)
      errores.responsables = `Faltan ${sinAsignar} responsable(s) por asignar`
  }
  return Object.keys(errores).length === 0
}

async function crearProceso() {
  if (!validarForm()) return
  guardando.value = true
  const esPrograma = esTipoPrograma(tipoModeloSeleccionado.value)

  // Institucional — rama según cantidad de campus
  if (!esPrograma) {
    if (instCampus.value.length === 1) {
      // Un solo campus → ejecución individual (sin ProcesoInstitucional)
      const result = await procesosStore.crear({
        ambito:       'institucional',
        id_version:   form.id_version,
        periodo:      form.periodo,
        id_campus:    instCampus.value[0],
        id_tipo_ejecucion_modelo: form.id_tipo_ejecucion_modelo,
        observaciones: form.observaciones?.trim() || undefined,
      })
      guardando.value = false
      if (!result.ok) {
        const msgs = result.errors ? Object.values(result.errors).flat().join(', ') : 'Error al crear el proceso'
        mostrarMensaje(msgs, 'error')
        return
      }
      cerrarFormulario()
      await procesosStore.cargarTodos()
      mostrarMensaje('Proceso institucional creado correctamente.', 'positivo')
      return
    }

    // Dos o más campus → ProcesoInstitucional general
    const result = await crearProcesoInstitucionalService({
      nombre:    instNombre.value.trim(),
      periodo:   form.periodo,
      id_version: form.id_version,
      id_tipo_ejecucion_modelo: form.id_tipo_ejecucion_modelo ?? null,
      criterio_consolidacion: instCriterio.value,
      observaciones: form.observaciones?.trim() || null,
      campus: instCampus.value,
    })
    guardando.value = false
    if (!result.ok) {
      mostrarMensaje(result.error ?? 'Error al crear el proceso institucional', 'error')
      return
    }
    cerrarFormulario()
    await Promise.all([procesosStore.cargarTodos(), cargarProcesosInstitucionales()])
    mostrarMensaje('Proceso institucional general creado correctamente.', 'positivo')
    return
  }

  // Programa — flujo con asignación de responsable
  const idVersion   = form.id_version
  const payload: Omit<Proceso, 'id' | 'estado'> = {
    ambito:        'programa',
    id_version:    idVersion,
    periodo:       form.periodo,
    id_programa:   form.id_programa,
    id_campus:     form.id_campus ?? undefined,
    id_tipo_ejecucion_modelo: form.id_tipo_ejecucion_modelo,
    observaciones: form.observaciones?.trim() || undefined
  }

  const result = await procesosStore.crear(payload)
  if (!result.ok || !result.data) {
    guardando.value = false
    const msgs = result.errors ? Object.values(result.errors).flat().join(', ') : 'Error al crear el proceso'
    mostrarMensaje(msgs, 'error')
    return
  }

  const idEjecucion   = result.data.id!
  const idAsignadoPor = authStore.usuarioActual?.id ?? null
  const todasFallidas: AsignacionFallida[] = []

  const version = await versionesStore.getVersionById(idVersion) as Version | null
  const idModelo = version?.id_modelo
  if (idModelo) {
    const raiz = await componentesStore.cargarRaizPorModelo(idModelo)
    if (raiz?.id_componente) await componentesStore.cargarArbolDesdeRaiz(raiz.id_componente)
  }
  const raizNodo = componentesStore.componentes[0]
  for (const comp of raizNodo?.children ?? []) {
    todasFallidas.push(...await asignarIndicadoresPorRama(idVersion, comp, usuarioResponsable.value!, idAsignadoPor, idEjecucion))
  }

  if (todasFallidas.length > 0) {
    const reintento = await asignarEnParalelo(todasFallidas)
    todasFallidas.length = 0
    todasFallidas.push(...reintento)
  }

  totalAsignacion.value = 0
  guardando.value = false
  cerrarFormulario()
  await procesosStore.cargarTodos()

  if (todasFallidas.length > 0) {
    asignacionesFallidas.value = todasFallidas
    mostrarReintentoAsignacion.value = true
    mostrarMensaje(`Proceso creado, pero ${todasFallidas.length} asignación(es) no se completaron.`, 'error')
  } else {
    mostrarMensaje('Proceso creado y asignado correctamente. Puede iniciarlo cuando esté listo.', 'positivo')
  }
}

async function reintentarAsignaciones() {
  reintentandoAsignacion.value = true
  const fallidas = await asignarEnParalelo([...asignacionesFallidas.value])
  asignacionesFallidas.value = fallidas
  reintentandoAsignacion.value = false
  if (fallidas.length === 0) {
    mostrarMensaje('Todas las asignaciones completadas correctamente.', 'positivo')
  } else {
    mostrarReintentoAsignacion.value = true
  }
}

async function iniciarProceso(id: number) {
  if (iniciandoId.value !== null) return
  const proceso = procesosStore.procesos.find(p => p.id === id)
  if (!proceso?.id_version) {
    mostrarMensaje('No se pudo obtener la versión del proceso.', 'error')
    return
  }
  iniciandoId.value = id
  try {
    const idsIndicadoresVersion = new Set(
      indicadoresStore.indicadores
        .filter(i => i.id_version === proceso.id_version && i.id_indicador != null)
        .map(i => i.id_indicador as number)
    )

    if (proceso.ambito === 'institucional') {
      await evaluadoresStore.cargar({ id_ejecucion: id })
      const conCalificar = new Set(
        evaluadoresStore.asignaciones
          .filter(a => a.tarea === 'calificar' && a.id_indicador != null && idsIndicadoresVersion.has(a.id_indicador))
          .map(a => a.id_indicador as number)
      )
      const sinAsignar = [...idsIndicadoresVersion].filter(idInd => !conCalificar.has(idInd))
      if (sinAsignar.length > 0) {
        mostrarMensaje(
          `No se puede iniciar: ${sinAsignar.length} indicador${sinAsignar.length === 1 ? '' : 'es'} sin responsable de calificación. Usa "Asignar responsables" primero.`,
          'error'
        )
        return
      }
    }

    const tieneInstrumentos = indicadorInstrumentoStore.relaciones
      .some(r => idsIndicadoresVersion.has(r.id_indicador))

    // El backend solo acepta preparacion → ejecucion como primer paso.
    // Si la versión no tiene instrumentos no hay fase de subida de evidencias:
    // se avanza inmediatamente a evaluacion independientemente de si es continuación.
    const saltarEjecucion = !tieneInstrumentos

    const step1 = await procesosStore.cambiarEstado(id, 'ejecucion')
    if (!step1.ok) {
      mostrarMensaje('No se pudo iniciar el proceso.', 'error')
      return
    }

    if (saltarEjecucion) {
      const step2 = await procesosStore.cambiarEstado(id, 'evaluacion')
      if (!step2.ok) {
        mostrarMensaje('No se pudo avanzar el proceso a evaluación.', 'error')
        await procesosStore.cargarTodos()
        return
      }
    }

    mostrarMensaje('Proceso iniciado correctamente.', 'positivo')
    await procesosStore.cargarTodos()
  } finally {
    iniciandoId.value = null
  }
}

// Adjuntar los informes que se generaron en su momento para una ejecución antigua.
function abrirAdjuntarInformes(p: Proceso) {
  if (!p.id) {
    mostrarMensaje('No se pudo identificar la ejecución.', 'error')
    return
  }
  adjuntarIdEjecucion.value = p.id
  adjuntarPeriodo.value = p.periodo ?? null
  adjuntarVisible.value = true
}

function alSubirInformes(cantidad: number) {
  mostrarMensaje(
    cantidad === 1 ? 'Archivo adjuntado correctamente.' : `${cantidad} archivos adjuntados correctamente.`,
    'positivo'
  )
}

function confirmarEliminar(id: number | undefined) {
  if (!id) {
    mostrarMensaje('No se pudo identificar el proceso.', 'error')
    return
  }
  procesoAEliminar.value = id
}

async function ejecutarEliminar() {
  if (procesoAEliminar.value === null || eliminando.value) return
  const id = procesoAEliminar.value
  procesoAEliminar.value = null
  eliminando.value = true
  try {
    const result = await procesosStore.eliminar(id)
    if (result.ok) {
      mostrarMensaje('Proceso eliminado.', 'positivo')
      await procesosStore.cargarTodos()
    } else {
      const msg = result.errors
        ? Object.values(result.errors).flat()[0] ?? 'No se pudo eliminar el proceso.'
        : 'No se pudo eliminar el proceso.'
      mostrarMensaje(msg, 'error')
    }
  } finally {
    eliminando.value = false
  }
}

onMounted(async () => {
  cargando.value = true
  await Promise.all([
    procesosStore.cargarTodos(),
    versionesStore.getVersiones(),
    programasStore.cargarTodos(),
    tipoModeloStore.getTipoModelos(),
    campusStore.cargarTodos(),
    indicadoresStore.cargarTodos(),
    indicadorInstrumentoStore.getRelaciones(),
    modeloStore.getModelo(),
    getTiposEjecucionModeloService().then(t => { tiposEjecucion.value = t }),
    cargarProcesosInstitucionales(),
  ])
  cargando.value = false
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LoadingOverlay, {
      visible: guardando.value,
      message: totalAsignacion.value > 0
        ? `Asignando indicadores... ${progresoAsignacion.value} / ${totalAsignacion.value}`
        : (modoEdicion.value ? 'Actualizando proceso...' : 'Creando proceso...')
    }, null, 8, ["visible", "message"]),
    _createVNode(LoadingOverlay, {
      visible: cargandoEdicion.value,
      message: "Cargando datos del proceso..."
    }, null, 8, ["visible"]),
    _createElementVNode("div", _hoisted_2, [
      _cache[33] || (_cache[33] = _createElementVNode("h1", null, "Gestión de Procesos de Autoevaluación", -1)),
      _createElementVNode("button", {
        class: "btn salir",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cambiar-modo')))
      }, "Cambiar modo")
    ]),
    _cache[81] || (_cache[81] = _createElementVNode("p", { class: "subtitulo" }, "Crea y asigna los procesos de autoevaluación", -1)),
    _cache[82] || (_cache[82] = _createElementVNode("div", { class: "divider" }, null, -1)),
    (!mostrarFormulario.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("button", {
            class: "btn guardar",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (mostrarFormulario.value = true))
          }, "Nuevo Proceso")
        ]))
      : _createCommentVNode("", true),
    (mostrarFormulario.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("h3", _hoisted_5, _toDisplayString(modoEdicion.value ? 'Modificar Proceso' : 'Nuevo Proceso'), 1),
          _createElementVNode("div", _hoisted_6, [
            _cache[37] || (_cache[37] = _createElementVNode("span", null, "Tipo Proceso", -1)),
            _createElementVNode("div", _hoisted_7, [
              (modoEdicion.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(tipoModeloStore).tipos.find(t => t.id_tipo_modelo === tipoModeloSeleccionado.value)?.tipo ?? '—'), 1))
                : _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 1,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((tipoModeloSeleccionado).value = $event)),
                    class: "input-select"
                  }, [
                    _cache[34] || (_cache[34] = _createElementVNode("option", {
                      value: null,
                      disabled: ""
                    }, "Selecciona un tipo de modelo", -1)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tipoModeloStore).tipos, (t) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: t.id_tipo_modelo,
                        value: t.id_tipo_modelo
                      }, _toDisplayString(t.tipo), 9, _hoisted_9))
                    }), 128))
                  ], 512)), [
                    [_vModelSelect, tipoModeloSeleccionado.value]
                  ]),
              _createElementVNode("div", _hoisted_10, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((periodoAnio).value = $event)),
                  class: "periodo-anio",
                  min: "2000",
                  max: anioMaximo,
                  step: "1",
                  "aria-label": "Año del periodo"
                }, null, 512), [
                  [
                    _vModelText,
                    periodoAnio.value,
                    void 0,
                    { number: true }
                  ]
                ]),
                _cache[36] || (_cache[36] = _createElementVNode("span", { class: "periodo-sep" }, "-", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((periodoSemestre).value = $event)),
                  class: "periodo-semestre",
                  "aria-label": "Semestre del periodo"
                }, _cache[35] || (_cache[35] = [
                  _createElementVNode("option", { value: "1" }, "1", -1),
                  _createElementVNode("option", { value: "2" }, "2", -1)
                ]), 512), [
                  [_vModelSelect, periodoSemestre.value]
                ])
              ])
            ])
          ]),
          (tipoModeloSeleccionado.value !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _cache[39] || (_cache[39] = _createElementVNode("span", null, [
                  _createTextVNode("Clase de proceso "),
                  _createElementVNode("b", { class: "req" }, "*")
                ], -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.id_tipo_ejecucion_modelo) = $event)),
                  class: "input-select"
                }, [
                  _cache[38] || (_cache[38] = _createElementVNode("option", {
                    value: undefined,
                    disabled: ""
                  }, "Selecciona para qué se autoevalúa", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tiposEjecucion.value, (t) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: t.id_tipo_ejecucion_modelo,
                      value: t.id_tipo_ejecucion_modelo
                    }, _toDisplayString(t.tipo), 9, _hoisted_12))
                  }), 128))
                ], 512), [
                  [_vModelSelect, form.id_tipo_ejecucion_modelo]
                ]),
                (errores.id_tipo_ejecucion_modelo)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_13, _toDisplayString(errores.id_tipo_ejecucion_modelo), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (tipoModeloSeleccionado.value !== null && esTipoPrograma(tipoModeloSeleccionado.value) && _unref(campusStore).campus.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _cache[41] || (_cache[41] = _createElementVNode("span", null, "Campus", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.id_campus) = $event)),
                  class: "input-select"
                }, [
                  _cache[40] || (_cache[40] = _createElementVNode("option", { value: undefined }, "— Sin campus específico —", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(campusStore).campus, (c) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: c.id_campus,
                      value: c.id_campus
                    }, _toDisplayString(c.nombre), 9, _hoisted_15))
                  }), 128))
                ], 512), [
                  [_vModelSelect, form.id_campus]
                ])
              ]))
            : _createCommentVNode("", true),
          (tipoModeloSeleccionado.value !== null && !esTipoPrograma(tipoModeloSeleccionado.value) && !modoEdicion.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _cache[42] || (_cache[42] = _createElementVNode("span", null, [
                  _createTextVNode("Campus participantes "),
                  _createElementVNode("b", { class: "req" }, "*")
                ], -1)),
                (!campusDisponibles.value.length)
                  ? (_openBlock(), _createElementBlock("p", _hoisted_17, "No hay campus registrados."))
                  : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(campusDisponibles.value, (c) => {
                        return (_openBlock(), _createElementBlock("label", {
                          key: c.id_campus,
                          class: "campus-item"
                        }, [
                          _withDirectives(_createElementVNode("input", {
                            type: "checkbox",
                            value: c.id_campus,
                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((instCampus).value = $event))
                          }, null, 8, _hoisted_19), [
                            [_vModelCheckbox, instCampus.value]
                          ]),
                          _createElementVNode("span", _hoisted_20, _toDisplayString(c.nombre), 1)
                        ]))
                      }), 128))
                    ])),
                (instCampus.value.length === 1)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_21, " Con un solo campus se crea una ejecución individual (sin proceso institucional general). "))
                  : _createCommentVNode("", true),
                (errores.campus)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_22, _toDisplayString(errores.campus), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (tipoModeloSeleccionado.value !== null && !esTipoPrograma(tipoModeloSeleccionado.value) && !modoEdicion.value && instCampus.value.length >= 2)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                _createElementVNode("div", _hoisted_23, [
                  _cache[43] || (_cache[43] = _createElementVNode("span", null, [
                    _createTextVNode("Nombre del proceso "),
                    _createElementVNode("b", { class: "req" }, "*")
                  ], -1)),
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((instNombre).value = $event)),
                    class: "input-select",
                    placeholder: "Autoevaluación Institucional 2026-1"
                  }, null, 512), [
                    [_vModelText, instNombre.value]
                  ]),
                  (errores.nombre)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_24, _toDisplayString(errores.nombre), 1))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _cache[45] || (_cache[45] = _createElementVNode("span", null, "Criterio de consolidación", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((instCriterio).value = $event)),
                    class: "input-select"
                  }, _cache[44] || (_cache[44] = [
                    _createElementVNode("option", { value: "ponderado" }, "Ponderado por número de programas", -1),
                    _createElementVNode("option", { value: "simple" }, "Promedio simple (cada campus pesa igual)", -1)
                  ]), 512), [
                    [_vModelSelect, instCriterio.value]
                  ]),
                  _createElementVNode("small", _hoisted_26, _toDisplayString(instCriterio.value === 'ponderado'
              ? 'Los campus con más programas tienen mayor peso en el consolidado.'
              : 'Todos los campus contribuyen con el mismo peso al consolidado.'), 1)
                ])
              ], 64))
            : _createCommentVNode("", true),
          (esTipoPrograma(tipoModeloSeleccionado.value))
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _cache[47] || (_cache[47] = _createElementVNode("span", null, "Programa", -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((form.id_programa) = $event)),
                  class: "input-select"
                }, [
                  _cache[46] || (_cache[46] = _createElementVNode("option", {
                    value: undefined,
                    disabled: ""
                  }, "Selecciona un programa", -1)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(areasPlanas.value, (op) => {
                    return (_openBlock(), _createElementBlock("option", {
                      key: op.id,
                      value: op.id
                    }, _toDisplayString(op.label), 9, _hoisted_28))
                  }), 128))
                ], 512), [
                  [_vModelSelect, form.id_programa]
                ]),
                (errores.id_programa)
                  ? (_openBlock(), _createElementBlock("small", _hoisted_29, _toDisplayString(errores.id_programa), 1))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          (tipoModeloSeleccionado.value !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                _cache[49] || (_cache[49] = _createElementVNode("span", null, "Versión", -1)),
                (modoEdicion.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, _toDisplayString(nombreVersion(form.id_version)), 1))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      (!versionesFiltradas.value.length)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, " No hay versiones disponibles para este tipo de proceso. "))
                        : _withDirectives((_openBlock(), _createElementBlock("select", {
                            key: 1,
                            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((form.id_version) = $event)),
                            class: "input-select"
                          }, [
                            _cache[48] || (_cache[48] = _createElementVNode("option", {
                              value: 0,
                              disabled: ""
                            }, "Selecciona una versión", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(versionesFiltradas.value, (v) => {
                              return (_openBlock(), _createElementBlock("option", {
                                key: v.id_version,
                                value: v.id_version
                              }, _toDisplayString(etiquetaVersion(v)), 9, _hoisted_33))
                            }), 128))
                          ], 512)), [
                            [_vModelSelect, form.id_version]
                          ]),
                      (errores.id_version)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_34, _toDisplayString(errores.id_version), 1))
                        : _createCommentVNode("", true)
                    ], 64))
              ]))
            : _createCommentVNode("", true),
          (tipoModeloSeleccionado.value !== null && form.id_version)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                (esTipoPrograma(tipoModeloSeleccionado.value))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                      _cache[51] || (_cache[51] = _createElementVNode("span", null, "Responsable del proceso", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((usuarioResponsable).value = $event)),
                        class: "input-select"
                      }, [
                        _cache[50] || (_cache[50] = _createElementVNode("option", {
                          value: null,
                          disabled: ""
                        }, "— Selecciona un responsable —", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usuarios.value, (u) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: u.id,
                            value: u.id
                          }, _toDisplayString(u.name), 9, _hoisted_36))
                        }), 128))
                      ], 512), [
                        [_vModelSelect, usuarioResponsable.value]
                      ]),
                      (errores.responsable)
                        ? (_openBlock(), _createElementBlock("small", _hoisted_37, _toDisplayString(errores.responsable), 1))
                        : _createCommentVNode("", true)
                    ]))
                  : (modoEdicion.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _cache[54] || (_cache[54] = _createElementVNode("span", null, "Responsables por componente", -1)),
                        (cargandoComponentes.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_39, "Cargando estructura del modelo..."))
                          : (componentesPrimerNivel.value.length)
                            ? (_openBlock(), _createElementBlock("table", _hoisted_40, [
                                _cache[53] || (_cache[53] = _createElementVNode("thead", null, [
                                  _createElementVNode("tr", null, [
                                    _createElementVNode("th", null, "Componente"),
                                    _createElementVNode("th", null, "Responsable")
                                  ])
                                ], -1)),
                                _createElementVNode("tbody", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(componentesPrimerNivel.value, (comp) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      key: comp.id_componente
                                    }, [
                                      _createElementVNode("td", null, _toDisplayString(comp.nombre), 1),
                                      _createElementVNode("td", null, [
                                        _withDirectives(_createElementVNode("select", {
                                          "onUpdate:modelValue": ($event: any) => ((responsablesPorComponente[comp.id_componente!]) = $event),
                                          class: "input-select select-usuario"
                                        }, [
                                          _cache[52] || (_cache[52] = _createElementVNode("option", {
                                            value: null,
                                            disabled: ""
                                          }, "— Selecciona un usuario —", -1)),
                                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(usuarios.value, (u) => {
                                            return (_openBlock(), _createElementBlock("option", {
                                              key: u.id,
                                              value: u.id
                                            }, _toDisplayString(u.name), 9, _hoisted_42))
                                          }), 128))
                                        ], 8, _hoisted_41), [
                                          [_vModelSelect, responsablesPorComponente[comp.id_componente!]]
                                        ])
                                      ])
                                    ]))
                                  }), 128))
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("div", _hoisted_43, "No se encontraron componentes de primer nivel.")),
                        (errores.responsables)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_44, _toDisplayString(errores.responsables), 1))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
              ], 64))
            : _createCommentVNode("", true),
          (tipoModeloSeleccionado.value !== null)
            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                _cache[55] || (_cache[55] = _createElementVNode("span", null, [
                  _createTextVNode("Observaciones "),
                  _createElementVNode("span", { class: "opcional" }, "(opcional)")
                ], -1)),
                _withDirectives(_createElementVNode("textarea", {
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((form.observaciones) = $event)),
                  class: "formulario-descripcion",
                  rows: "3",
                  placeholder: "Notas adicionales sobre el proceso..."
                }, null, 512), [
                  [_vModelText, form.observaciones]
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("button", {
              class: "btn salir",
              onClick: cerrarFormulario
            }, "Cancelar"),
            (modoEdicion.value || tipoModeloSeleccionado.value !== null)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn guardar",
                  disabled: guardando.value,
                  onClick: _cache[14] || (_cache[14] = ($event: any) => (modoEdicion.value ? modificarProceso() : crearProceso()))
                }, _toDisplayString(guardando.value ? (modoEdicion.value ? 'Guardando...' : 'Creando...') : (modoEdicion.value ? 'Guardar cambios' : 'Crear Proceso')), 9, _hoisted_47))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (cargando.value && !mostrarFormulario.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_48, "Cargando procesos..."))
      : (!mostrarFormulario.value)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
            _createElementVNode("div", _hoisted_49, [
              _createElementVNode("button", {
                class: _normalizeClass(["proceso-tab", { 'proceso-tab-activo': filtroTipo.value === 'programa' }]),
                onClick: _cache[15] || (_cache[15] = ($event: any) => (filtroTipo.value = 'programa'))
              }, " Programas ", 2),
              _createElementVNode("button", {
                class: _normalizeClass(["proceso-tab", { 'proceso-tab-activo': filtroTipo.value === 'institucional' }]),
                onClick: _cache[16] || (_cache[16] = ($event: any) => (filtroTipo.value = 'institucional'))
              }, " Institucional ", 2),
              _createElementVNode("button", {
                class: _normalizeClass(["proceso-tab", { 'proceso-tab-activo': filtroTipo.value === 'institucional-general' }]),
                onClick: _cache[17] || (_cache[17] = ($event: any) => {filtroTipo.value = 'institucional-general'; mostrarFormVincular.value = false})
              }, " Institucional General ", 2)
            ]),
            (filtroTipo.value === 'institucional-general')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_50, [
                    _createElementVNode("button", {
                      class: "btn guardar",
                      onClick: _cache[18] || (_cache[18] = ($event: any) => (mostrarFormVincular.value = true)),
                      disabled: mostrarFormVincular.value
                    }, " Vincular ejecuciones existentes ", 8, _hoisted_51)
                  ]),
                  (cargandoInstitucionales.value)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_52, "Cargando procesos institucionales..."))
                    : (!procesosInstitucionalesFiltrados.value.length)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_53, " No hay procesos institucionales generales. Crea uno vinculando ejecuciones de campus existentes. "))
                      : (_openBlock(), _createElementBlock("table", _hoisted_54, [
                          _cache[56] || (_cache[56] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                              _createElementVNode("th", null, "Nombre"),
                              _createElementVNode("th", null, "Período"),
                              _createElementVNode("th", null, "Versión"),
                              _createElementVNode("th", null, "Campus"),
                              _createElementVNode("th", null, "Acciones")
                            ])
                          ], -1)),
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(procesosInstitucionalesFiltrados.value, (pi) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: pi.id_proceso_institucional
                              }, [
                                _createElementVNode("td", null, _toDisplayString(pi.nombre), 1),
                                _createElementVNode("td", null, _toDisplayString(pi.periodo), 1),
                                _createElementVNode("td", null, _toDisplayString(pi.version?.nombre ?? nombreVersion(pi.id_version)), 1),
                                _createElementVNode("td", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((pi.ejecuciones ?? []), (e) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                      key: e.id_ejecucion,
                                      class: "chip-campus-inst"
                                    }, _toDisplayString(e.campus?.nombre ?? '—'), 1))
                                  }), 128))
                                ]),
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_55, [
                                    _createElementVNode("button", {
                                      class: "btn guardar btn-tabla",
                                      onClick: ($event: any) => (irAResultadosInstitucional(pi))
                                    }, " Resultados ", 8, _hoisted_56)
                                  ])
                                ])
                              ]))
                            }), 128))
                          ])
                        ])),
                  (mostrarFormVincular.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_57, [
                        _cache[67] || (_cache[67] = _createElementVNode("h3", { class: "form-titulo" }, "Vincular ejecuciones existentes", -1)),
                        _cache[68] || (_cache[68] = _createElementVNode("p", { class: "aviso-version" }, " Todas las ejecuciones a vincular deben usar la misma versión del modelo. La versión que selecciones aquí determina qué ejecuciones institucionales se muestran disponibles por campus. ", -1)),
                        _createElementVNode("div", _hoisted_58, [
                          _cache[57] || (_cache[57] = _createElementVNode("span", null, [
                            _createTextVNode("Nombre "),
                            _createElementVNode("b", { class: "req" }, "*")
                          ], -1)),
                          _withDirectives(_createElementVNode("input", {
                            "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formVincular.nombre) = $event)),
                            class: "input-select",
                            placeholder: "Autoevaluación Institucional 2026-1"
                          }, null, 512), [
                            [_vModelText, formVincular.nombre]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_59, [
                          _createElementVNode("div", _hoisted_60, [
                            _cache[59] || (_cache[59] = _createElementVNode("span", null, [
                              _createTextVNode("Versión "),
                              _createElementVNode("b", { class: "req" }, "*")
                            ], -1)),
                            _withDirectives(_createElementVNode("select", {
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formVincular.id_version) = $event)),
                              class: "input-select"
                            }, [
                              _cache[58] || (_cache[58] = _createElementVNode("option", {
                                value: 0,
                                disabled: ""
                              }, "Selecciona una versión", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(versionesStore).versiones, (v) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  key: v.id_version,
                                  value: v.id_version
                                }, _toDisplayString(v.nombre), 9, _hoisted_61))
                              }), 128))
                            ], 512), [
                              [_vModelSelect, formVincular.id_version]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_62, [
                            _cache[62] || (_cache[62] = _createElementVNode("span", null, [
                              _createTextVNode("Período "),
                              _createElementVNode("b", { class: "req" }, "*")
                            ], -1)),
                            _createElementVNode("div", _hoisted_63, [
                              _withDirectives(_createElementVNode("input", {
                                type: "number",
                                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formVincularAnio).value = $event)),
                                class: "periodo-anio",
                                min: "2000",
                                max: anioMaximo,
                                step: "1",
                                "aria-label": "Año"
                              }, null, 512), [
                                [
                                  _vModelText,
                                  formVincularAnio.value,
                                  void 0,
                                  { number: true }
                                ]
                              ]),
                              _cache[61] || (_cache[61] = _createElementVNode("span", { class: "periodo-sep" }, "-", -1)),
                              _withDirectives(_createElementVNode("select", {
                                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((formVincularSemestre).value = $event)),
                                class: "periodo-semestre",
                                "aria-label": "Semestre"
                              }, _cache[60] || (_cache[60] = [
                                _createElementVNode("option", { value: "1" }, "1", -1),
                                _createElementVNode("option", { value: "2" }, "2", -1)
                              ]), 512), [
                                [_vModelSelect, formVincularSemestre.value]
                              ])
                            ])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_64, [
                          _cache[63] || (_cache[63] = _createElementVNode("span", null, [
                            _createTextVNode("Campus a incluir "),
                            _createElementVNode("b", { class: "req" }, "*"),
                            _createTextVNode(),
                            _createElementVNode("small", { class: "opcional" }, "(mínimo 2)")
                          ], -1)),
                          _createElementVNode("div", _hoisted_65, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(campusStore).campus, (c) => {
                              return (_openBlock(), _createElementBlock("label", {
                                key: c.id_campus,
                                class: "campus-item"
                              }, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "checkbox",
                                  value: c.id_campus,
                                  "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((campusParaVincular).value = $event))
                                }, null, 8, _hoisted_66), [
                                  [_vModelCheckbox, campusParaVincular.value]
                                ]),
                                _createElementVNode("span", _hoisted_67, _toDisplayString(c.nombre), 1)
                              ]))
                            }), 128))
                          ]),
                          (campusParaVincular.value.length === 1)
                            ? (_openBlock(), _createElementBlock("small", _hoisted_68, " Se necesitan al menos 2 campus para crear un proceso institucional general. "))
                            : _createCommentVNode("", true)
                        ]),
                        (campusParaVincular.value.length >= 2 && formVincular.id_version && formVincular.periodo)
                          ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(procesosParaVincular.value, (grupo) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: grupo.idCampus,
                                class: "formulario-opcion grupo-campus-vincular"
                              }, [
                                _createElementVNode("span", _hoisted_69, _toDisplayString(grupo.campusNombre), 1),
                                (!grupo.procesos.length)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_70, " Sin ejecuciones para esta versión y período — se creará una nueva. "))
                                  : (_openBlock(), _createElementBlock("table", _hoisted_71, [
                                      _cache[64] || (_cache[64] = _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                          _createElementVNode("th", null, "#"),
                                          _createElementVNode("th", null, "Período"),
                                          _createElementVNode("th", null, "Estado")
                                        ])
                                      ], -1)),
                                      _createElementVNode("tbody", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(grupo.procesos, (p) => {
                                          return (_openBlock(), _createElementBlock("tr", {
                                            key: p.id
                                          }, [
                                            _createElementVNode("td", null, _toDisplayString(p.id), 1),
                                            _createElementVNode("td", null, _toDisplayString(p.periodo), 1),
                                            _createElementVNode("td", null, [
                                              _createElementVNode("span", {
                                                class: _normalizeClass(['estado', estadoClass(p.estado)])
                                              }, _toDisplayString(p.estado), 3)
                                            ])
                                          ]))
                                        }), 128))
                                      ])
                                    ])),
                                (grupo.procesos.length)
                                  ? (_openBlock(), _createElementBlock("small", _hoisted_72, " Esta ejecución quedará vinculada al proceso institucional general. "))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_73, [
                          _cache[66] || (_cache[66] = _createElementVNode("span", null, "Criterio de consolidación", -1)),
                          _withDirectives(_createElementVNode("select", {
                            "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((formVincular.criterio_consolidacion) = $event)),
                            class: "input-select"
                          }, _cache[65] || (_cache[65] = [
                            _createElementVNode("option", { value: "ponderado" }, "Ponderado por número de programas", -1),
                            _createElementVNode("option", { value: "simple" }, "Promedio simple (cada campus pesa igual)", -1)
                          ]), 512), [
                            [_vModelSelect, formVincular.criterio_consolidacion]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_74, [
                          _createElementVNode("button", {
                            class: "btn salir",
                            onClick: _cache[25] || (_cache[25] = ($event: any) => {mostrarFormVincular.value = false; campusParaVincular.value = []})
                          }, "Cancelar"),
                          _createElementVNode("button", {
                            class: "btn guardar",
                            disabled: guardandoVincular.value || !formVincular.nombre.trim() || !formVincular.id_version || campusParaVincular.value.length < 2,
                            onClick: crearProcesoDesdeExistentes
                          }, _toDisplayString(guardandoVincular.value ? 'Creando...' : 'Crear proceso general'), 9, _hoisted_75)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("div", _hoisted_76, [
                    _createElementVNode("div", _hoisted_77, [
                      _cache[70] || (_cache[70] = _createElementVNode("label", { class: "filtro-label" }, "Estado:", -1)),
                      _withDirectives(_createElementVNode("select", {
                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((filtroEstado).value = $event)),
                        class: "select-filtro"
                      }, [
                        _cache[69] || (_cache[69] = _createElementVNode("option", { value: "" }, "Todos", -1)),
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(opcionesEstado, (e) => {
                          return _createElementVNode("option", {
                            key: e.value,
                            value: e.value
                          }, _toDisplayString(e.label), 9, _hoisted_78)
                        }), 64))
                      ], 512), [
                        [_vModelSelect, filtroEstado.value]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_79, [
                      _cache[71] || (_cache[71] = _createElementVNode("span", { class: "filtro-label" }, "Buscar:", -1)),
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((busqueda).value = $event)),
                        type: "text",
                        class: "input-busqueda",
                        placeholder: "Período..."
                      }, null, 512), [
                        [_vModelText, busqueda.value]
                      ])
                    ])
                  ]),
                  (!procesosFiltrados.value.length)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_80, _toDisplayString(filtroTipo.value === 'institucional' ? 'No hay ejecuciones institucionales por campus.' : 'No hay procesos de programa.'), 1))
                    : (_openBlock(), _createElementBlock("table", _hoisted_81, [
                        _createElementVNode("thead", null, [
                          _createElementVNode("tr", null, [
                            _cache[72] || (_cache[72] = _createElementVNode("th", null, "#", -1)),
                            _cache[73] || (_cache[73] = _createElementVNode("th", null, "Versión", -1)),
                            _cache[74] || (_cache[74] = _createElementVNode("th", null, "Tipo", -1)),
                            _createElementVNode("th", null, _toDisplayString(filtroTipo.value === 'institucional' ? 'Campus' : 'Programa'), 1),
                            _cache[75] || (_cache[75] = _createElementVNode("th", null, "Período", -1)),
                            _cache[76] || (_cache[76] = _createElementVNode("th", null, "Estado", -1)),
                            _cache[77] || (_cache[77] = _createElementVNode("th", null, "Observaciones", -1)),
                            _cache[78] || (_cache[78] = _createElementVNode("th", null, "Acciones", -1))
                          ])
                        ]),
                        _createElementVNode("tbody", null, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(procesosFiltrados.value, (p) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              key: p.id
                            }, [
                              _createElementVNode("td", null, _toDisplayString(p.id), 1),
                              _createElementVNode("td", null, _toDisplayString(nombreVersion(p.id_version)), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(['badge-ambito', p.ambito === 'institucional' ? 'badge-ambito-inst' : 'badge-ambito-prog'])
                                }, _toDisplayString(p.ambito), 3)
                              ]),
                              _createElementVNode("td", null, _toDisplayString(p.ambito === 'institucional'
                ? (p.campus?.nombre ?? _unref(campusStore).campus.find(c => c.id_campus === p.id_campus)?.nombre ?? '—')
                : nombrePrograma(p.id_programa)), 1),
                              _createElementVNode("td", null, _toDisplayString(p.periodo), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(['estado', estadoClass(p.estado)])
                                }, _toDisplayString(p.estado ?? '—'), 3)
                              ]),
                              _createElementVNode("td", _hoisted_82, _toDisplayString(p.observaciones || '—'), 1),
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_83, [
                                  (p.estado === 'preparacion')
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "btn guardar btn-tabla",
                                        disabled: cargandoEdicion.value,
                                        onClick: ($event: any) => (abrirModificarProceso(p))
                                      }, " Modificar ", 8, _hoisted_84))
                                    : _createCommentVNode("", true),
                                  (_unref(authStore).tienePermiso('procesos.asignar') && p.ambito === 'institucional' && p.estado === 'preparacion')
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: "btn guardar btn-tabla",
                                        onClick: ($event: any) => (irAAsignarTareas(p.id))
                                      }, " Asignar responsables ", 8, _hoisted_85))
                                    : _createCommentVNode("", true),
                                  (p.estado === 'preparacion')
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 2,
                                        class: "btn guardar btn-tabla",
                                        disabled: iniciandoId.value === p.id,
                                        onClick: ($event: any) => (iniciarProceso(p.id!))
                                      }, _toDisplayString(iniciandoId.value === p.id ? 'Iniciando...' : 'Iniciar proceso'), 9, _hoisted_86))
                                    : _createCommentVNode("", true),
                                  (_unref(authStore).tienePermiso('procesos.asignar') && p.ambito === 'institucional' && ['ejecucion', 'evaluacion'].includes(p.estado ?? ''))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 3,
                                        class: "btn guardar btn-tabla",
                                        onClick: ($event: any) => (irAAsignarTareas(p.id))
                                      }, " Asignar tareas ", 8, _hoisted_87))
                                    : _createCommentVNode("", true),
                                  (_unref(authStore).tienePermiso('calificacion.ver') && ['informe', 'finalizado'].includes(p.estado ?? '') && !esProcesoHistorico(p))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 4,
                                        class: "btn guardar btn-tabla",
                                        onClick: ($event: any) => (irAComparativo(p.id))
                                      }, " Comparativo ", 8, _hoisted_88))
                                    : _createCommentVNode("", true),
                                  (_unref(authStore).tienePermiso('calificacion.ver') && ['informe', 'finalizado'].includes(p.estado ?? ''))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 5,
                                        class: "btn guardar btn-tabla",
                                        onClick: ($event: any) => (irAResultados(p.id))
                                      }, " Resultados ", 8, _hoisted_89))
                                    : _createCommentVNode("", true),
                                  (_unref(authStore).tienePermiso('informes.ver') && p.estado === 'informe' && !esProcesoHistorico(p))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 6,
                                        class: "btn guardar btn-tabla",
                                        onClick: ($event: any) => (irAInforme(p.id))
                                      }, " Informe ", 8, _hoisted_90))
                                    : _createCommentVNode("", true),
                                  (_unref(authStore).tienePermiso('planes.ver') && ['informe', 'finalizado'].includes(p.estado ?? '') && !esProcesoHistorico(p))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 7,
                                        class: "btn guardar btn-tabla",
                                        onClick: ($event: any) => (irAPlanMejoramiento(p.id))
                                      }, " Plan de mejoramiento ", 8, _hoisted_91))
                                    : _createCommentVNode("", true),
                                  (_unref(authStore).tienePermiso('informes.ver') && esProcesoHistorico(p) && ['informe', 'finalizado'].includes(p.estado ?? ''))
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 8,
                                        class: "btn guardar btn-tabla",
                                        onClick: ($event: any) => (abrirAdjuntarInformes(p))
                                      }, " Adjuntar Informes ", 8, _hoisted_92))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("button", {
                                    class: "btn salir btn-tabla",
                                    onClick: ($event: any) => (confirmarEliminar(p.id))
                                  }, "Eliminar", 8, _hoisted_93)
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ]))
                ], 64))
          ], 64))
        : _createCommentVNode("", true),
    (procesoAEliminar.value !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_94, [
          _createElementVNode("div", _hoisted_95, [
            _createElementVNode("p", null, [
              _cache[79] || (_cache[79] = _createTextVNode("¿Eliminar el proceso ")),
              _createElementVNode("strong", null, "#" + _toDisplayString(procesoAEliminar.value), 1),
              _cache[80] || (_cache[80] = _createTextVNode("? Esta acción no se puede deshacer."))
            ]),
            _createElementVNode("div", _hoisted_96, [
              _createElementVNode("button", {
                class: "btn salir",
                disabled: eliminando.value,
                onClick: _cache[28] || (_cache[28] = ($event: any) => (procesoAEliminar.value = null))
              }, "Cancelar", 8, _hoisted_97),
              _createElementVNode("button", {
                class: "btn guardar",
                disabled: eliminando.value,
                onClick: ejecutarEliminar
              }, _toDisplayString(eliminando.value ? 'Eliminando...' : 'Confirmar'), 9, _hoisted_98)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(AdjuntarInformesModal, {
      visible: adjuntarVisible.value,
      idEjecucion: adjuntarIdEjecucion.value,
      periodo: adjuntarPeriodo.value,
      onCerrar: _cache[29] || (_cache[29] = ($event: any) => (adjuntarVisible.value = false)),
      onSubido: alSubirInformes
    }, null, 8, ["visible", "idEjecucion", "periodo"]),
    _createVNode(MensajeConfirmacion, {
      visible: mostrarReintentoAsignacion.value,
      title: "Asignaciones incompletas",
      message: `${asignacionesFallidas.value.length} asignación(es) no se completaron. ¿Desea volver a intentarlas?`,
      confirmText: "Reintentar",
      cancelText: "Cancelar",
      confirmLoading: reintentandoAsignacion.value,
      onConfirm: _cache[30] || (_cache[30] = ($event: any) => {mostrarReintentoAsignacion.value = false; reintentarAsignaciones()}),
      onCancel: _cache[31] || (_cache[31] = ($event: any) => (mostrarReintentoAsignacion.value = false))
    }, null, 8, ["visible", "message", "confirmLoading"]),
    _createVNode(MensajeFlotante, {
      visible: mensajeVisible.value,
      mensaje: mensajeTexto.value,
      tipo: mensajeTipo.value,
      onCerrar: _cache[32] || (_cache[32] = ($event: any) => (mensajeVisible.value = false))
    }, null, 8, ["visible", "mensaje", "tipo"])
  ]))
}
}

})